import { AfterViewInit, Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { LoaderService } from '../../shared/loader/loader.service';
import { NotificationService } from '../../shared/utils/notification.service';
import { compareValidator } from '../../_common/validation/compare.validator';
import { validatePassword } from '../../_common/validation/password.validator';
import { LoginService } from '../../_services/login.service';
import { GenericFormValidator } from './../../_common/validation/generic-form.validator';
import { AtualizaSenha } from './../../_models/atualiza-senha';

@Component({
  selector: 'app-atualiza-senha',
  templateUrl: './atualiza-senha.component.html'
})
export class AtualizaSenhaComponent implements OnInit, AfterViewInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  public form: FormGroup;
  private genericValidator: GenericFormValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  private userId: string;
  private code: string;
  displayMessage: { [key: string]: string } = {};

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private notificationService: NotificationService,
    private loader: LoaderService,
    private activateRoute: ActivatedRoute,
    private route: Router) {

    this.genericValidator = new GenericFormValidator(this.validationMessages);
    this.configurarValidacaoFormulario();
  }

  ngOnInit() {
    this.activateRoute.params.subscribe(param => {
      this.userId = param['userId'];
      this.code = param['code'];
    })
    this.configurarFormulario();
  }

  atualizar(model: AtualizaSenha) {
    if (this.form.invalid) { return; }

    model.code = this.code;
    model.userId = this.userId;

    this.loader.queue('atualizarSenha');
    this.loginService.atualizarSenha(model).subscribe(
      () => {
        this.notificationService.exibirNotificacaoSucesso('Sucesso', 'Sua senha foi atualizada.');
        this.route.navigate(['/']);
      },
      error => {
        this.loader.dequeue('atualizarSenha');
        this.notificationService.exibirNotificacaoAlerta('Atenção', error.join('</br>'));
      },
      () => {
        this.loader.dequeue('atualizarSenha');
      }
    )
  }

  ngAfterViewInit() {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    Observable.merge(...controlBlurs).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.form);
    });
  }

  get textoRegrasCriacaoSenha() {
    return `Regras para composição da senha:
            <em><br/> - Deve conter pelo menos uma letra maíuscula;
            <br/> - Deve conter pelo menos uma letra minuscula;
            <br/> - Deve conter pelo menos um caracter especial;
            <br/> - Deve ter o tamanho no minimo de 8 posições.</em>`
  }

  private configurarValidacaoFormulario() {
    this.validationMessages = {
      usuario: {
        required: 'Por favor, informe o usuário.',
        minlength: 'Por favor, informe ao menos 3 dígitos para o usuário.'
      },
      senha: {
        required: 'Por favor, informe a senha.',
        minlength: 'Por favor, informe ao menos 8 dígitos para a senha.',
        invalidPassword: ' A senha fornecida não atende aos requisitos mínimos de segurança.'
      },
      confirmaSenha: {
        required: 'Por favor, repita a senha.',
        compare: ' As senhas não correspondemmm.'
      }
    };

    this.genericValidator = new GenericFormValidator(this.validationMessages);
  }

  private configurarFormulario() {
    this.form = this.formBuilder.group({
      usuario: [null,
        [
          Validators.required
        ]
      ],
      senha: [null,
        [
          Validators.required,
          Validators.minLength(8),
          validatePassword
        ]
      ],
      confirmaSenha: [null,
        [
          Validators.required,
          compareValidator('senha')
        ]
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/atualiza-senha/atualiza-senha.component.ts